<script lang="ts">
	import iconClose from '@/icons/icon_close.svg'
	import IconCheckmark from '$svg/icon-checkmark.svg?component'
	import { t } from '$i18n/i18n'
	import Button from '#lib/atoms/Button.svelte'

	interface Props {
		step: number
		totalSteps: number
		onnext?: () => void
		onabort?: () => void
	}

	let { step, totalSteps, onnext, onabort }: Props = $props()
</script>

<div class="error-tour-tt">
	<div class="error-tour-tt__header">
		<span>{$t('Analyticals.tour.tooltip.title')}</span>
		<button type="button" class="error-tour-tt__close" onclick={() => onabort?.()}>
			<img src={iconClose} width="20" height="20" alt="Close" />
		</button>
	</div>
	<div class="error-tour-tt__body">
		<div>
			<span>{$t('Analyticals.tour.tooltip.desc')}</span>
			<div>
				<span>{$t('Analyticals.input.tooltip.title')}</span>
				<div style="display: grid; grid-template-columns: 50px 1fr; padding-top: 4px;">
					<span style="color: #58C078;">{$t('Analyticals.input.tooltip.nn')}</span>
					<span>{$t('Analyticals.input.tooltip.nn.desc')}</span>
					<span style="color: #58C078;">{@html $t('Analyticals.input.tooltip.ltValue')}</span>
					<span>{$t('Analyticals.input.tooltip.ltValue.desc')}</span>
					<span style="color: #58C078;">{@html $t('Analyticals.input.tooltip.gtValue')}</span>
					<span>{$t('Analyticals.input.tooltip.gtValue.desc')}</span>
					<span style="color: #58C078;">{$t('Analyticals.input.tooltip.ng')}</span>
					<span>{$t('Analyticals.input.tooltip.ng.desc')}</span>
				</div>
			</div>
		</div>
		<div class="error-tour-tt__footer">
			<span class="error-tour-tt__steps">{step} {$t('Grammar.from')} {totalSteps}</span>
			<Button variant="primary" onclick={() => onnext?.()}>
				{$t('UI.button.checked')}
				<IconCheckmark />
			</Button>
		</div>
	</div>
</div>

<style>
	.error-tour-tt {
		display: flex;
		min-width: 150px;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		gap: 4px;
		padding-top: 2px;
		padding-bottom: 2px;
	}

	.error-tour-tt__close {
		background: none;
		border: none;
		padding: 0;
		cursor: pointer;
		display: flex;
	}

	.error-tour-tt__header {
		width: 100%;
		display: flex;
		align-items: flex-start;
		justify-content: space-between;
		gap: 10px;

		& > span {
			color: #000;
			font-family: Roboto, sans-serif;
			font-size: 12px;
			font-style: normal;
			font-weight: 500;
			line-height: 20px;
		}
	}

	.error-tour-tt__body {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 10px;
		align-self: stretch;

		& > div > span {
			color: #000;
			font-family: Roboto, sans-serif;
			font-size: 12px;
			font-style: normal;
			font-weight: 400;
			line-height: 20px;
		}
	}

	.error-tour-tt__footer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 10px;
		align-self: stretch;

		& > .error-tour-tt__steps {
			color: var(--primary-green);
			font-family: Roboto, sans-serif;
			font-size: 12px;
			font-style: normal;
			font-weight: 400;
			line-height: 18px;
		}
	}
</style>
